import { render } from "./Zoomableimage.vue?vue&type=template&id=1d043c86&scoped=true"
import script from "./Zoomableimage.vue?vue&type=script&lang=js"
export * from "./Zoomableimage.vue?vue&type=script&lang=js"

import "./Zoomableimage.vue?vue&type=style&index=0&id=1d043c86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d043c86"]])

export default __exports__